const ASSESSMENT_TYPE = {
    Quiz: 'progress',
    TRYOUT: 'tryout',
    MILESTONE: 'milestone',
    OTHER: 'other',
}
export default ASSESSMENT_TYPE
